;
define("global_views_breadcrumb.tpl", function(){});

